module.exports = __webpack_public_path__ + "static/media/stopSmall.8dafc8b3.svg";